import ExecutaRest from '../util/ExecutaRest'

class MensagemApi {

    static Validar(parametros) {


        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {
            
            rest.Post('MensagemSL.svc/rest/ValidarREST', parametros).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> Validar: ' + error /*areaTratamento.statusText*/);
            });

        });

    }


    static ObterMensagemPorProtocoloSenha(parametros) {


        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {
            
            rest.Post('MensagemSL.svc/rest/ObterMensagemPorProtocoloSenhaREST', parametros).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> ObterMensagemPorProtocoloSenha: ' + error /*areaTratamento.statusText*/);
            });

        });

    }

    static SolicitarAutenticacaoPorProtocoloSenha(parametros) {
        var rest = new ExecutaRest();
        return new Promise(function (resolve, reject) {
            
            rest.Post('MensagemSL.svc/rest/SolicitarAutenticacaoPorProtocoloSenhaREST', parametros).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> SolicitarAutorizacaoPorProtocoloSenhaREST: ' + error /*areaTratamento.statusText*/);
            });
        });
    }

    static Cadastrar(parametros) {


        var rest = new ExecutaRest();
        
        return new Promise(function (resolve, reject) {
            rest.Post('MensagemSL.svc/rest/GravarREST', parametros).then(retorno => {
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> GravarREST: ' + error /*areaTratamento.statusText*/);
            });

        });

    }

    static Tramitar(parametros) {
        var rest = new ExecutaRest();
        
        return new Promise(function (resolve, reject) {
            rest.Post('MensagemSL.svc/rest/TramitarMensagemAppFormREST', parametros).then(retorno => {
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> TramitarMensagemREST: ' + error /*areaTratamento.statusText*/);
            });

        });

    }
}

 export default MensagemApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/mensagemApi.js
 **/